
<!--  -->
<template>
  <div class="comContent">
    <div class="title">
      <div>
        <el-form ref="formTool"
                 :model="formTool"
                 :inline="true">
          <el-form-item label="部门名称"
                        prop="deptName">
            <el-input v-model="formTool.deptName"
                      style="width: 150px;"
                      size="small"
                      placeholder="请输入部门名称" />
          </el-form-item>
          <el-form-item label="部门负责人"
                        prop="deptPrincipal">
            <el-input v-model="formTool.deptPrincipal"
                      style="width: 150px;"
                      size="small"
                      placeholder="请输入部门负责人" />
          </el-form-item>
          <el-form-item label="部门ERPid"
                        prop="deptErpId">
            <el-input v-model="formTool.deptErpId"
                      style="width: 150px;"
                      size="small"
                      placeholder="请输入部门ERPid" />
          </el-form-item>
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="formTool.status"
                       style="width: 150px;"
                       size="small"
                       placeholder="请选择状态"
                       clearable
                       >
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <div>
        <el-button type="primary" size="small" @click="getList(1)" >查询</el-button>
        <el-button size="small" @click="reset()">重置</el-button>
      </div>
    </div>
    <div class="center">
      <MyTable :table-data="tableData"
               :index="index"
               :selection="selection"
               :page="page"
               :operation="operation"
               :table-option.sync="tableOption"
               @page-change="getList"
               @handleSelectionChange="currentChange">
        <template slot="status"
                  slot-scope="scope">
          <span>{{scope.row.status ? '开启':'关闭'}}</span>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from '@/components/myTable'
import { externalsalesdeptinfoPageForOPS } from '@/api/salesControl/commodity'


export default {
  components: { MyTable }, // , MenuForm, MyTabs, MyTable, MyTypes
  data () {
    return {
      clearable: true,
      formTool: {
        deptName: '',
        deptPrincipal: '',
        deptErpId: '',
        status: '',
        shopId: ''
      },
      options: [{
        value: '1',
        label: '开启'
      }, {
        value: '0',
        label: '关闭'
      }],
      operation: false,
      selection: false,
      index: false, // 不展示序号，自己重新定义了序号
      tableData: [
      ],
      tableOption: [
        { label: '部门名称', prop: 'deptName' },
        { label: '部门负责人', prop: 'deptPrincipal' }, // 这里表示自定义列 , slot: true
        // { label: '在职状态', prop: 'roleCode' },
        { label: '运营联系电话', prop: 'operationPhone' },
        // { label: '用户ID', prop: 'userCode' },
        // { label: '角色', prop: 'roleDesc' },
        { label: '部门ERPid', prop: 'deptErpId' },
        { label: '状态', prop: 'status', slot: true },
        { label: 'ERP同步商品数量', prop: 'erpGoodsCount' },
        { label: '商品在售数量', prop: 'onSaleGoodsCount' },
      ],
      page: { total: 0, current: 1, size: 10 },
      beMainDept:true, //是不是主部门
    }
  },
  computed: {
  },
  watch: {},
  created () {
    let query = this.$route.query;
    if(query.shopId){
      this.formTool.shopId = query.shopId;
    }
    this.getList()
  },
  mounted () { 
  
},
  methods: {
    // 查询列表
    getList (num) {
      if (num) {
        this.page.current = num
      }
      console.log(this.page, 'getList')
      const { current, size } = this.page
      let d = { current, size, ...this.formTool }
      this.listLoading = true
      externalsalesdeptinfoPageForOPS(d).then((res) => {
        this.tableData = res.records
        this.page.total = res.total
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    reset () {
      this.formTool = { deptName: '', deptPrincipal: '', deptErpId: '' }
      // this.$refs.formTool.resetFields()
      this.page.current = 1
      this.getList(1)
    },
    currentChange (val) {
      console.log('current', val)
    },
  }
}
</script>
<style lang='scss' scoped>
.comContent {
  padding: 0px;
  .title {
    height: 56px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5ff;
    .el-form-item {
      margin-bottom: 0px !important;
    }
  }
  .center {
    margin: 0 24px;
    margin-top: 16px;
    height: calc(100% - 131px);
  }
}
</style>
